import { render, staticRenderFns } from "./renewAlarm.vue?vue&type=template&id=3b3e7280&scoped=true"
import script from "./renewAlarm.vue?vue&type=script&lang=js"
export * from "./renewAlarm.vue?vue&type=script&lang=js"
import style0 from "./renewAlarm.vue?vue&type=style&index=0&id=3b3e7280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e7280",
  null
  
)

export default component.exports